/**
 * @author Srijan Shakya
 * @description https://marvelapp.com/4g4b5dg/screen/60580195/layer/103561811
 */

import React, { memo } from 'react';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';

const EmployeeQuotaList = ({ data, navigate, onReport, onShowModal }) => {
    return (
        <>
            <p className="dsl-b16 bold my-2 text-start">Employee assigned</p>
            <div className="d-flex">
                <div className="d-flex-4">
                    <p className="dsl-m10 text-400 text-start">Employee name</p>
                </div>
                <div className="d-flex-1 text-end">
                    <p className="dsl-m10 text-400">Actuals</p>
                </div>
            </div>
            {data.map((item, index) => {
                const { id, profile, actual_average } = item;
                const { first_name, last_name, avatar } = profile;
                return (
                    index < 10 && (
                        <div className="d-flex py-1" key={index} onClick={() => onReport(id)}>
                            <div className="d-flex d-flex-4">
                                <Avatar className="d-flex-1" name={`${first_name} ${last_name}`} url={avatar} onToggle={() => navigate(`/library/record-employee-info/${id}`)} />
                                <div className="d-flex-3 dsl-b14 ms-2 text-start text-400 ai-s-center">{`${first_name} ${last_name}`}</div>
                            </div>
                            <div className="d-flex-1 text-end dsl-b12 text-400 ai-s-center">
                                <span className="dsl-b12 text-400"> {actual_average}</span>
                            </div>
                        </div>
                    )
                );
            })}
            <div className="d-h-end">
                <Button className="employees-button" name="SHOW MORE" onClick={onShowModal} />
            </div>
        </>
    );
};

export default memo(EmployeeQuotaList);
